export default __webpack_public_path__ + "static/media/title_animation_vp9_10KB_crf10.efcd9a6a.webm";